<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const badges = ['stripe', 'gdpr', 'eu', 'local'] as const
</script>

<template>
  <section class="bg-slate-50 py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p class="text-center text-slate-400 text-xs font-semibold uppercase tracking-widest mb-10">
        {{ t('organizers_lp.trust.label') }}
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div
          v-for="badge in badges"
          :key="badge"
          class="bg-white rounded-xl p-6 border border-slate-100 text-center"
        >
          <div class="w-8 h-8 text-emerald-500 mx-auto mb-3">
            <!-- Stripe -->
            <svg v-if="badge === 'stripe'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <rect x="6" y="6" width="28" height="28" rx="4" stroke="currentColor" stroke-width="2.5" />
              <path d="M13 20h14M13 26h8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <path d="M13 14h8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
            </svg>
            <!-- GDPR -->
            <svg v-else-if="badge === 'gdpr'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <path d="M20 4L8 10v10c0 7.18 5.14 13.9 12 15.5C27.86 33.9 32 27.18 32 20V10L20 4z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" />
              <path d="M14 20l4 4 8-8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <!-- EU -->
            <svg v-else-if="badge === 'eu'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="20" cy="20" r="14" stroke="currentColor" stroke-width="2.5" />
              <path d="M6 20h28M20 6c-3 4-5 8-5 14s2 10 5 14M20 6c3 4 5 8 5 14s-2 10-5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            <!-- Local -->
            <svg v-else viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <path d="M20 4C13.373 4 8 9.373 8 16c0 9 12 20 12 20s12-11 12-20c0-6.627-5.373-12-12-12z" stroke="currentColor" stroke-width="2.5" />
              <circle cx="20" cy="16" r="4" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>
          <h3 class="text-sm font-bold text-slate-900">{{ t(`organizers_lp.trust.${badge}_title`) }}</h3>
          <p class="text-xs text-slate-500 mt-2 leading-relaxed">{{ t(`organizers_lp.trust.${badge}_body`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
